import React from 'react';
import {images} from "../../constants"
import { SubHeading} from '../../components';

const FindUs = () => (
  <div className='app__bg app__wrapper section__padding' id='contact'>
    <div className="app__wrapper_info">
      <SubHeading title = "contact" />
      <h1 className="headtext__cormorant" style={{marginBottom: "3rem"}} >Hungry for spicy food? Visit Us</h1>
      <div className="app__wrapper-content">
        <p className="p__opensans">6 Portico Parade, Toongabbie NSW 2146</p>
        <p className="p__cormorant" style={{color: "#dcca87", margin: "2rem 0"}} >Business Hours</p>
        <p className="p__opensans">Mon-Fri: 09:00 am - 10:00 pm</p>
        <p className="p__opensans">Sat-Sun: 09:00 am - 10:00 pm</p>
      </div>
      
    </div>
    <div className="app__wrapper_img">
      <img src = {images.findus} alt = "find us" />
    </div>
  </div>
);

export default FindUs;
